import { styled } from "@mui/material/styles";
import { Box, Typography, ListItem } from "@mui/material";

export const SidebarRoot = styled(Box)({
  height: "100vh",
  backgroundColor: "#1e2a38",
  color: "white",
  display: "flex",
  flexDirection: "column",
});

export const Logo = styled(Typography)({
  padding: "20px 16px",
  color: "white",
  fontWeight: 500,
  fontSize: "20px",
});

export const StyledListItem = styled(ListItem)(({ active }) => ({
  color: active ? "#2196f3" : "#ffffff",
  padding: "8px 16px",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  },
  "& .MuiListItemIcon-root": {
    color: active ? "#2196f3" : "#ffffff",
    minWidth: "40px",
  },
}));

export const SubMenuItem = styled(ListItem)(({ active }) => ({
  padding: "8px 16px 8px 56px",
  color: active ? "#2196f3" : "#ffffff",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  },
}));
